
import { createAction, props } from "@ngrx/store";
import { EntityEtapasEmpresa } from "./entity-etapas-empresa.model";

export const EntityEtapasEmpresaLoadRequest = createAction(
  '[ENTITYETAPASEMPRESA] Load Request'
);

export const EntityEtapasEmpresaLoadFailure = createAction(
  '[ENTITYETAPASEMPRESA] Load Failure',
  props<{ error: Error }>()
);

export const EntityEtapasEmpresaLoadSuccess = createAction(
  '[ENTITYETAPASEMPRESA] Load Success',
  props<{ items: EntityEtapasEmpresa[] }>()
);

export const EntityEtapasEmpresaAddRequest = createAction(
  '[ENTITYETAPASEMPRESA] Add Request',
  props<{ item: EntityEtapasEmpresa }>()
);

export const EntityEtapasEmpresaAddFailure = createAction(
  '[ENTITYETAPASEMPRESA] Add Failure',
  props<{ error: Error }>()
);

export const EntityEtapasEmpresaAddSuccess = createAction(
  '[ENTITYETAPASEMPRESA] Add Success',
  props<{ item: EntityEtapasEmpresa }>()
);

export const EntityEtapasEmpresaDeleteRequest = createAction(
  '[ENTITYETAPASEMPRESA] Delete Request',
  props<{ item: EntityEtapasEmpresa }>()
);

export const EntityEtapasEmpresaDeleteFailure = createAction(
  '[ENTITYETAPASEMPRESA] Delete Failure',
  props<{ error: Error }>()
);

export const EntityEtapasEmpresaDeleteSuccess = createAction(
  '[ENTITYETAPASEMPRESA] Delete Success',
  props<{ item: EntityEtapasEmpresa }>()
);

export const EntityEtapasEmpresaUpdateRequest = createAction(
  '[ENTITYETAPASEMPRESA] Update Request',
  props<{ item: EntityEtapasEmpresa }>()
);

export const EntityEtapasEmpresaUpdateFailure = createAction(
  '[ENTITYETAPASEMPRESA] Update Failure',
  props<{ error: Error }>()
);

export const EntityEtapasEmpresaUpdateSuccess = createAction(
  '[ENTITYETAPASEMPRESA] Update Success',
  props<{ item: EntityEtapasEmpresa }>()
);
